import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject, of } from 'rxjs';
import { debounceTime, switchMap, catchError, filter, map, distinctUntilChanged } from 'rxjs/operators';
import { Franco } from '../business/franco/franco';
import { FrancoService } from '../business/franco/franco.service';

@Injectable({
  providedIn: 'root'
})
export class FrancoStateService {
  private francoSubject = new BehaviorSubject<Franco | null>(null);
  public franco$ = this.francoSubject.asObservable();

  private refreshTrigger$ = new Subject<{order: any, customerCode: string, companyCode: string}>();

  constructor(private francoService: FrancoService) {
    this.refreshTrigger$.pipe(
      debounceTime(300),
      distinctUntilChanged((prev, curr) => JSON.stringify(prev) === JSON.stringify(curr)),
      filter(data => !!data.order && !!data.customerCode),
      switchMap(data => {
        const francoInput = {
          customerId: data.customerCode,
          companyCode: data.companyCode === 'PRONATURAFRANCE' ? 'PRONATURA' : 'VITAFRAIS',
          deliveryDate: data.order.deliveryDate.substring(0, 10),
          deliveryAdress: data.order.deliveryAddress.code,
          warehouse: data.order.departureMagasin ? data.order.departureMagasin : ''
        };
        return this.francoService.getCommonFranco(francoInput).pipe(
          catchError(() => of(null))
        );
      })
    ).subscribe(franco => {
      this.francoSubject.next(franco);
    });
  }

  public refreshFranco(order: any, customerCode: string, companyCode: string) {
    this.refreshTrigger$.next({ order, customerCode, companyCode });
  }
}